import React from 'react';
import { clsx } from 'clsx';

type Props = {
  className?: string;
  title: string;
  subtitle?: string;
};

export const Headline: React.FC<Props> = ({ title, subtitle, className }) => (
  <div className={clsx('mb-6 px-4 sm:px-0', className)}>
    <h1 className="text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl sm:leading-10">
      {title}
    </h1>

    {subtitle && <h3 className="mt-4 max-w-3xl mx-auto text-xl leading-7 text-gray-500">{subtitle}</h3>}
  </div>
);
